module.exports = __webpack_public_path__ + "img/travel4.6cd77885.jpg";